import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import secureRequest from '@app/helpers/secure-request';
import { TemplateKey } from '@app/types/reducer-state';

import { GET_KEYS } from '../constants/endpoints';
import Key from '../models/key';

export const initialState = {
  keys: [],
  loadedTemplate: false,
  loadingTemplate: false,
  loadedTemplateError: false,
  templateIndex: 0,
  showTemplateSelector: false,
  loadedTemplateText: '',
  // Set when an operator picks a template; retained across composer edits until
  // send/schedule or leaving the chat (job/chat switch / unmount).
  selectedMessageTemplateId: null as string | null,
};

export const getKeys = createAsyncThunk('templates/get-keys', async () => {
  const args = {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'GET',
  };

  const response = await secureRequest(GET_KEYS, args);
  const json = await response.json();
  return json.map((t: TemplateKey) => new Key(t));
});

export const templatesSlice = createSlice({
  name: 'templates',
  initialState,
  reducers: {
    selectTemplate: (state, action) => ({
      ...state,
      loadedTemplateText: action.payload.text,
      selectedMessageTemplateId: action.payload.id ?? null,
    }),
    // Clears the Redux handoff after the composer copies text + id into local state.
    clearLoadedTemplate: (state) => ({
      ...state,
      loadedTemplate: false,
      loadedTemplateText: '',
      selectedMessageTemplateId: null,
    }),
    clearSelectedMessageTemplateId: (state) => ({
      ...state,
      selectedMessageTemplateId: null,
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(getKeys.fulfilled, (state, action) => {
      const keys = action.payload;
      let changes = {};
      if (keys) {
        changes = {
          keys,
        };
      }
      return { ...state, ...changes };
    });
  },
});
